module.exports = __webpack_public_path__ + "img/ltkstyletip-1x.b1e9c5f.jpg";